<template>
  <div class="order-detail-page">
    <div class="breadcrumb flex-rowl">
      <div class="breadcrumb-icon"></div>
      <div class="breadcrumb-content flex-rowl">
        <div class="breadcrumb-content-item" @click="handleReturn">
          业务订单中心
        </div>
        <div class="breadcrumb-content-arr"><van-icon name="arrow" /></div>
        <div class="breadcrumb-content-item">{{ detail.order_id }}</div>
      </div>
    </div>

    <!-- 加载提示 -->
    <div class="common-loading-wrap flex-rowc" v-if="isLoading">
      <van-loading type="spinner" vertical>加载中...</van-loading>
    </div>

    <div class="main-wrap" v-else>
      <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
        <div class="common-list-item">
          <div class="order-info-wrap flex-rowl">
            <div class="order-icon"></div>
            <div class="order-content">
              <p>订单编号：</p>
              <p class="flex-rowl">
                {{ detail.order_id }} <span
                    class="copy-icon"
                    :data-clipboard-text="detail.order_id"
                    @click.capture="handleCopyBtn(detail.order_id)"
                  ></span>
              </p>
              <p class="txt">{{ formatTime(detail.create_time)}}</p>
              <div class="label">服务类型：{{ detail.servicecontstr }}</div>
            </div>
          </div>
          <div
            class="user-info-wrap"
            v-if="detail.park_catering_service_order_obj"
          >
            <div class="name flex-rowl">
              对象：{{
                detail.park_catering_service_order_obj
                  ? detail.park_catering_service_order_obj.truename
                  : ""
              }}<a
                :href="`tel:${
                  detail.park_catering_service_order_obj &&
                  detail.park_catering_service_order_obj.mobile
                    ? detail.park_catering_service_order_obj.mobile
                    : ''
                }`"
                class="tel-icon"
              ></a>
            </div>
            <div class="file-list-wrap" v-if="columnSubService.certsstr">
              <div class="tit">代办手续所需的证件或材料证明</div>
              <div class="sub-tit">{{ columnSubService.certsstr }}：</div>
              <div class="file-list flex-rowl">
                <div
                  class="file-item"
                  v-for="(item, index) in images"
                  :key="index"
                  @click="previewImage(index, images)"
                >
                  <van-image
                    width="100%"
                    height="100%"
                    :src="item"
                    fit="cover"
                    class="file-item-img"
                  />
                </div>
              </div>
            </div>

            <div class="state">
              <p>
                状态：<span class="blue">{{
                  detail.service_order_statusstr
                }}</span>
                <span v-if="detail.service_order_status == 6" class="blue">{{
                  detail.service_rating == 1
                    ? "不满意"
                    : detail.service_rating == 2
                    ? "满意"
                    : detail.service_rating == 3
                    ? "非常满意"
                    : ""
                }}</span>
              </p>
            </div>
            <div class="price-block">
              <div class="price-wrap">
                <p>
                  基础费用：<span :class="{ red: !detail.timeoutprice }">{{
                    detail.timeoutprice ? "¥" + detail.timeoutprice : "待核算"
                  }}</span>
                </p>
                <p>
                  支付状态：<span
                    :class="{ red: detail.isreturn != 2 }"
                    v-if="detail.isreturn == 1"
                    >{{
                      detail.returncheck == 1
                        ? "已退款"
                        : detail.returncheck == 2
                        ? "退款，不同意"
                        : "退款中"
                    }}</span
                  >
                  <span :class="{ red: detail.ispay != 1 }" v-else>{{
                    detail.ispaystr ? detail.ispaystr : "待支付"
                  }}</span>
                  <span
                    class="management-btn"
                    v-if="
                      detail.service_order_status == 8 &&
                      detail.ispay == 1 &&
                      detail.isreturn != 1
                    "
                    @click.stop="handleShowManagePopup(2)"
                    >管理</span
                  >
                </p>
                <p>
                  支付方式：<span>{{
                    detail.ispaystr
                      ? detail.paytype == 1
                        ? detail.paytypestr
                        : detail.paytypestr +
                          "，" +
                          (detail.getmancardno ? "已确认" : "待确认")
                      : ""
                  }}</span>
                </p>
              </div>
              <!-- 超时收费 -->
              <div class="price-wrap">
                <p>
                  超时费用：<span :class="{ red: !timeoutChargeObj.fee }">{{
                    timeoutChargeObj.fee ? "¥" + timeoutChargeObj.fee : "无"
                  }}</span>
                </p>
                <p>
                  支付状态：<span
                    :class="{ red: timeoutChargeObj.paystate != 1 }"
                    >{{
                      timeoutChargeObj.paystate == 1
                        ? "已支付"
                        : timeoutChargeObj.paystate == 2
                        ? "待支付"
                        : "无"
                    }}</span
                  >
                </p>
                <p>
                  支付方式：<span v-if="timeoutChargeObj.paytype">{{
                    timeoutChargeObj.paytype == 1
                      ? "线上支付"
                      : "线下现金结算" +
                        "，" +
                        (timeoutChargeObj.hrcode ? "已确认" : "待确认")
                  }}</span
                  ><span class="red" v-else>无</span>
                </p>
              </div>
              <!-- 额外交通费用 -->
              <div class="price-wrap">
                <p>
                  额外交通费用：<span :class="{ red: !extraChargeObj.fee }">{{
                    extraChargeObj.fee ? "¥" + extraChargeObj.fee : "无"
                  }}</span>
                </p>
                <p>
                  支付状态：<span
                    :class="{ red: extraChargeObj.paystate != 1 }"
                    >{{
                      extraChargeObj.paystate == 1
                        ? "已支付"
                        : extraChargeObj.paystate == 2
                        ? "待支付"
                        : "无"
                    }}</span
                  >
                </p>
                <p>
                  支付方式：<span v-if="extraChargeObj.paytype">{{
                    extraChargeObj.paytype == 1
                      ? "线上支付"
                      : "线下现金结算" +
                        "，" +
                        (extraChargeObj.hrcode ? "已确认" : "待确认")
                  }}</span
                  ><span class="red" v-else>无</span>
                </p>
              </div>
              <!-- 其他额外费用 -->
              <div class="price-wrap">
                <p>
                  其他额外费用：<span
                    :class="{ red: !otherExtraChargeObj.id }"
                    >{{
                      otherExtraChargeObj.id
                        ? "¥" + otherExtraChargeObj.fee
                        : "无"
                    }}</span
                  >
                  <span v-if="otherExtraChargeObj.feetype">{{
                    otherExtraChargeObj.feetype == 1
                      ? "药品购买费用"
                      : otherExtraChargeObj.feetype == 2
                      ? "挂号费"
                      : otherExtraChargeObj.feetype == 3
                      ? "检查预约付费"
                      : otherExtraChargeObj.feetype == 4
                      ? "住院押金"
                      : "其它额外费用"
                  }}</span>
                </p>
                <p>
                  支付状态：<span
                    :class="{ red: otherExtraChargeObj.paystate != 1 }"
                    >{{
                      otherExtraChargeObj.paystate == 1
                        ? "已支付"
                        : otherExtraChargeObj.paystate == 2
                        ? "待支付"
                        : "无"
                    }}</span
                  >
                </p>
                <p>
                  支付方式：<span v-if="otherExtraChargeObj.paytype">{{
                    otherExtraChargeObj.paytype == 1
                      ? "线上支付"
                      : "线下现金结算" +
                        "，" +
                        (otherExtraChargeObj.hrcode ? "已确认" : "待确认")
                  }}</span
                  ><span class="red" v-else>无</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="common-card-list">
          <div class="common-card-item flex-between">
            <div class="content">
              <p>需要办理手续的医院</p>
              <template v-if="detail.needinaddr">
                <p class="txt">{{ detail.needinaddr }}</p>
                <p class="txt">
                  {{ detail.provincestr }} {{ detail.citystr }}
                  {{ detail.areastr }}
                </p>
                <p class="txt">
                  {{ detail.addr }}
                </p>
              </template>
              <p v-else>未选择医院</p>
            </div>
          </div>
          <div class="common-card-item flex-between">
            <div class="content">
              <p>需要办理的时间</p>
              <p class="txt">
                {{ formatTime(detail.asktime) }}
              </p>
            </div>
          </div>
          <div class="common-card-item flex-between">
            <div class="content">
              <p>手续类型</p>
              <p class="txt">
                {{ columnSubService.yuantypestr }}
              </p>
            </div>
          </div>
          <!-- 业务过程 start -->
          <template v-for="(item, index) in detailtypeList">
            <div
              class="common-card-item service-process flex-between"
              :key="index"
              v-if="item.isShow"
            >
              <div class="content">
                <p v-html="item.html"></p>
              </div>
              <div class="operation-wrap flex-rowr">
                <div
                  class="operation-btn flex-rowc"
                  :class="{ finish: item.isFinish || detail.service_order_status < 3 || (detail.paytype == 2 && !detail.getmancardno) }"
                  @click="showCustomPopup('bottom', 1, item)"
                >
                  {{ item.isFinish ? "已完成" : "服务流程管理" }}
                </div>
                <!-- isFinish 为 true 时，显示操作图标 -->
                <div
                  v-if="item.isFinish"
                  class="operation-icon"
                  @click="showCustomPopup('bottom', 1, item)"
                ></div>
              </div>
            </div>
          </template>

          <!-- 额外费用 -->
          <div
            class="common-card-item extra-card-item flex-between"
            v-if="timeoutChargeObj.id"
          >
            <div class="icon"></div>
            <div class="content">
              <div class="title flex-between">
                <p>服务超时追加费用</p>
                <p
                  class="state"
                  :class="{ blue: timeoutChargeObj.paystate != 1 }"
                >
                  {{ timeoutChargeObj.paystate == 1 ? "已支付" : "待支付" }}
                </p>
              </div>
              <div class="price-state-wrap flex-rowl">
                <div class="price">
                  <span>¥</span>{{ timeoutChargeObj.fee }}
                </div>
                <div class="state">{{ timeoutChargeObj.checkstate == 1 ? '审核通过' : timeoutChargeObj.checkstate == 2 ? '审核未通过' : '审核中' }}</div>
              </div>
              <div
                class="btn flex-rowc"
                :class="{ disabled: timeoutChargeObj.hrcode }"
                @click="showCustomPopup('center', 3, 2)"
              >
                <span class="icon" v-if="!timeoutChargeObj.hrcode"></span
                >{{ timeoutChargeObj.hrcode ? "已确认" : "收费管理" }}
              </div>
            </div>
          </div>

          <!-- 额外交通费用 -->
          <div
            class="common-card-item extra-card-item flex-between"
            v-if="extraChargeObj.id"
          >
            <div class="icon"></div>
            <div class="content">
              <div class="title flex-between">
                <p>额外交通费用</p>
                <p
                  class="state"
                  :class="{ blue: extraChargeObj.paystate != 1 }"
                >
                  {{ extraChargeObj.paystate == 1 ? "已支付" : "待支付" }}
                </p>
              </div>
              <div class="price-state-wrap flex-rowl">
                <div class="price">
                  <span>¥</span>{{ extraChargeObj.fee }}
                </div>
                <div class="state">{{ extraChargeObj.checkstate == 1 ? '审核通过' : extraChargeObj.checkstate == 2 ? '审核未通过' : '审核中' }}</div>
              </div>
              <div
                class="btn flex-rowc"
                :class="{ disabled: extraChargeObj.hrcode }"
                @click="showCustomPopup('center', 3, 3)"
              >
                <span class="icon" v-if="!extraChargeObj.hrcode"></span
                >{{ extraChargeObj.hrcode ? "已确认" : "收费管理" }}
              </div>
            </div>
          </div>

          <!-- 其他额外费用 -->
          <div
            class="common-card-item extra-card-item flex-between"
            v-if="otherExtraChargeObj.id"
          >
            <div class="icon"></div>
            <div class="content">
              <div class="title flex-between">
                <p>
                  {{
                    otherExtraChargeObj.feetype == 1
                      ? "药品购买费用"
                      : otherExtraChargeObj.feetype == 2
                      ? "挂号费"
                      : otherExtraChargeObj.feetype == 3
                      ? "检查预约付费"
                      : otherExtraChargeObj.feetype == 4
                      ? "住院押金"
                      : "其它额外费用"
                  }}
                </p>
                <p
                  class="state"
                  :class="{ blue: otherExtraChargeObj.paystate != 1 }"
                >
                  {{ otherExtraChargeObj.paystate == 1 ? "已支付" : "待支付" }}
                </p>
              </div>
              <div class="price-state-wrap flex-rowl">
                <div class="price">
                  <span>¥</span>{{ otherExtraChargeObj.fee }}
                </div>
                <div class="state">{{ otherExtraChargeObj.checkstate == 1 ? '审核通过' : otherExtraChargeObj.checkstate == 2 ? '审核未通过' : '审核中' }}</div>
              </div>
              <div
                class="btn flex-rowc"
                :class="{ disabled: otherExtraChargeObj.hrcode }"
                @click="showCustomPopup('center', 3, 4)"
              >
                <span class="icon" v-if="!otherExtraChargeObj.hrcode"></span
                >{{ otherExtraChargeObj.hrcode ? "已确认" : "收费管理" }}
              </div>
            </div>
          </div>
          <!-- 其他 -->
        </div>
      </van-pull-refresh>
    </div>

    <div class="bottom-wrap flex-rowc">
      <div class="bottom-wrap-return flex-rowc" @click="handleReturn">
        <span class="icon"></span> 返回
      </div>
      <!-- :class="{ disabled: isSubmitting }" -->
      <div
        class="bottom-wrap-btn flex-rowc"
        @click="showCustomPopup('bottom', 2)"
        v-if="detail.service_order_property != 2"
      >
        收费管理
      </div>
      <!-- :class="{ disabled: isSubmitting }" -->
      <div
        class="bottom-wrap-btn flex-rowc"
        :class="{disabled: detail.service_order_status < 3  || (detail.paytype == 2 && !detail.getmancardno)}"
        @click="showCustomPopup('center', 4)"
        v-if="detail.service_order_property != 2"
      >
        服务完成
      </div>
    </div>

    <CustomPopup
      :visible="isShowCustomPopup"
      :position="popupPosition"
      @close="closeCustomPopup"
    >
      <!-- 服务流程 -->
      <template v-if="popupType == 1">
        <div class="service-process-custom-popup">
          <div class="popup-title flex-rowc">
            {{
              detailtypeobj.type == "radio"
                ? "是否预约成功"
                : detailtypeobj.text
            }}
          </div>
          <div class="radio-wrap" v-if="detailtypeobj.type == 'radio'">
            <van-radio-group v-model="detailtypeobj.radioValue">
              <van-radio name="1">已办理完成</van-radio>
              <!-- <van-radio name="2">预约失败</van-radio> -->
            </van-radio-group>
          </div>
          <div class="service-process-content">
            <div class="pic-list flex-rowl">
              <div
                class="pic-item"
                v-for="(item, index) in tempPicList"
                :key="index"
                @click="previewImage(index, tempPicList)"
              >
                <van-image width="100%" height="100%" fit="cover" :src="item" />
                <div
                  class="delete-btn flex-rowc"
                  @click="removeImage(index)"
                  v-if="!isFinishShowBtn"
                >
                  <van-icon name="delete-o" /> 删除
                </div>
              </div>
              <div
                class="pic-item flex-rowc"
                v-if="tempPicList.length < 3 && !isFinishShowBtn"
              >
                <van-icon name="plus" />
                <input
                  ref="imageInput"
                  type="file"
                  accept="image/*"
                  style="opacity: 0"
                  @change="handleFileChange"
                />
              </div>
            </div>
          </div>
          <div
            class="btn-wrap flex-rowc"
            @click="confirmServiceProcess"
            v-if="!isFinishShowBtn"
          >
            服务流程完成确认
          </div>
        </div>
      </template>
      <!-- 收费管理类别 -->
      <template v-else-if="popupType == 2">
        <div class="charge-type-custom-popup">
          <div class="popup-title flex-rowc">选择收费管理类别</div>
          <div
            class="btn-wrap info flex-rowc"
            @click="showCustomPopup('center', 3, 1)"
          >
            基础服务管理费用
          </div>
          <div
            class="btn-wrap info flex-rowc"
            @click="showCustomPopup('center', 3, 2)"
          >
            超时服务管理费用
          </div>
          <div
            class="btn-wrap info flex-rowc"
            @click="showCustomPopup('center', 3, 3)"
          >
            额外交通费用管理
          </div>
          <div
            class="btn-wrap info flex-rowc"
            @click="showCustomPopup('center', 3, 4)"
          >
            其他额外费用管理
          </div>
        </div>
      </template>
      <!-- 收费管理 -->
      <template v-else-if="popupType == 3">
        <div class="charge-custom-popup">
          <div class="popup-title flex-rowc">
            {{
              chargeType == 1
                ? "基础服务管理费用"
                : chargeType == 2
                ? "超时服务管理费用"
                : chargeType == 3
                ? "额外交通费用管理"
                : "其他额外费用管理"
            }}
          </div>
          <div class="charge-popup-content flex-colc" v-if="!isAddExtraCharge">
            <!-- 有记录 -->
            <div class="record-wrap flex-colc" v-if="isHasChargeRecord">
              <div class="type" v-if="chargeType == 4">
                {{
                  otherExtraChargeObj.feetype == 1
                    ? "药品购买费用"
                    : otherExtraChargeObj.feetype == 2
                    ? "挂号费"
                    : otherExtraChargeObj.feetype == 3
                    ? "检查预约付费"
                    : otherExtraChargeObj.feetype == 4
                    ? "住院押金"
                    : "其它额外费用"
                }}
              </div>
              <div class="tit">
                {{ isHasFinishCharge ? "已" : "待" }}确认的线下支付记录
              </div>
              <p><span>¥</span>{{ chargeAmount }}</p>
              <div
                class="btn flex-rowc"
                :class="{
                  disabled: isSubmitting,
                  success: isHasFinishCharge,
                }"
                @click="confirmChargeManagement"
              >
                {{ isHasFinishCharge ? "已确认" : "确认收款" }}
              </div>
            </div>
            <!-- 无记录 -->
            <div class="no-record flex-colc" v-else>
              <div class="icon"></div>
              <div class="txt">没有需要处理的记录</div>
              <div
                class="btn-wrap flex-rowc"
                v-if="
                  (chargeType == 2 && !timeoutChargeObj.id) ||
                  (chargeType == 3 && !extraChargeObj.id) ||
                  (chargeType == 4 && !otherExtraChargeObj.id)
                "
                @click="addChargeRecord"
              >
                {{
                  chargeType == 2
                    ? "新增超时收费记录"
                    : chargeType == 3
                    ? "新增额外交通费用记录"
                    : "新增其他额外费用记录"
                }}
              </div>
            </div>
          </div>
          <!-- 是否新增额外收费记录 -->
          <div class="extra-charge-popup-content" v-else>
            <!-- 超时收费 -->
            <div class="extra-charge-block" v-if="chargeType == 2">
              <div class="tit flex-rowc">超时时长</div>
              <div class="stepper-wrap flex-between">
                <div
                  class="stepper-btn left flex-rowc"
                  :class="{ disabled: stepperValue <= 0.5 }"
                  @click="decrement"
                >
                  −
                </div>
                <input
                  type="number"
                  class="stepper-input"
                  :value="stepperValue"
                  @input="handleInput"
                  min="1"
                  step="1"
                />
                <div class="stepper-btn right flex-rowc" @click="increment">
                  +
                </div>
              </div>
            </div>
            <!-- 额外交通费用 -->
            <div class="extra-charge-block" v-if="chargeType == 3">
              <div class="tit flex-rowc">填写交通费用金额</div>
              <div class="price-wrap flex-between">
                <input
                  type="number"
                  class="stepper-input"
                  v-model="timeoutAmount"
                />
              </div>
              <!-- 交通凭证-图片 -->
              <div class="extra-charge-pic" v-if="chargeType == 3">
                <div class="tit flex-rowc">
                  上传凭证({{ tempPicList.length }}/3)
                </div>
                <div class="pic-list flex-rowl">
                  <div
                    class="pic-item"
                    v-for="(item, index) in tempPicList"
                    :key="index"
                  >
                    <van-image
                      width="100%"
                      height="100%"
                      fit="cover"
                      :src="item"
                    />
                    <div
                      class="delete-btn flex-rowc"
                      @click="removeImage(index)"
                    >
                      <van-icon name="delete-o" /> 删除
                    </div>
                  </div>
                  <div
                    class="pic-item flex-rowc"
                    v-if="tempPicList.length < 3 && !isFinishShowBtn"
                  >
                    <van-icon name="plus" />
                    <input
                      ref="imageInput"
                      type="file"
                      accept="image/*"
                      style="opacity: 0"
                      @change="handleFileChange"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 其他额外费用 -->
            <div class="extra-charge-block" v-if="chargeType == 4">
              <div class="tit flex-rowc">收费类型及金额</div>
              <div class="radio-list-wrap">
                <van-radio-group
                  v-model="extraChargeType"
                  direction="horizontal"
                >
                  <van-radio
                    v-for="item in extraChargeTypeList"
                    :key="item.value"
                    :name="item.value"
                    >{{ item.text }}</van-radio
                  >
                </van-radio-group>
              </div>
              <div class="price-wrap flex-between">
                <input
                  type="number"
                  class="stepper-input"
                  v-model="timeoutAmount"
                />
              </div>
              <div class="extra-charge-pic">
                <div class="tit flex-rowc">
                  上传凭证({{ tempPicList.length }}/3)
                </div>
                <div class="pic-list flex-rowl">
                  <div
                    class="pic-item"
                    v-for="(item, index) in tempPicList"
                    :key="index"
                  >
                    <van-image
                      width="100%"
                      height="100%"
                      fit="cover"
                      :src="item"
                    />
                    <div
                      class="delete-btn flex-rowc"
                      @click="removeImage(index)"
                    >
                      <van-icon name="delete-o" /> 删除
                    </div>
                  </div>
                  <div
                    class="pic-item flex-rowc"
                    v-if="tempPicList.length < 3 && !isFinishShowBtn"
                  >
                    <van-icon name="plus" />
                    <input
                      ref="imageInput"
                      type="file"
                      accept="image/*"
                      style="opacity: 0"
                      @change="handleFileChange"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="btn-group-wrap flex-colc">
              <div
                class="btn-wrap primary flex-rowc"
                :class="{ disabled: isSubmitting }"
                @click="addServiceManagementCharge"
              >
                确认
              </div>
              <div class="btn-wrap flex-rowc" @click="returnChargeRecord">
                返回
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 是否确认服务已完成 -->
      <template v-else-if="popupType == 4">
        <div class="finish-service-custom-popup">
          <div class="popup-title flex-rowc">是否确认服务 <br />已经完成？</div>
          <div class="select-wrap">
            <div class="select-item flex-rowc" @click="confirmFinishService(2)">
              是
            </div>
            <div class="select-item flex-rowc" @click="confirmFinishService(3)">
              否
            </div>
          </div>
        </div>
      </template>
    </CustomPopup>
  </div>
</template>
  
  <script>
  import Clipboard from "clipboard";
import {
  getCommunityServiceOrderDetail,
  addBusinessRecord,
  editCommunityServiceOrder,
  addTimeoutCharge,
  editTimeoutCharge,
  addExtraTransportationCharge,
  editExtraTransportationCharge,
  addOtherExtraCharge,
  editOtherExtraCharge,
  getHospitalProceduresList,
  editHospitalProcedures,
} from "../../../api/api";
import { uploadImage } from "../../../api/public";
import CustomPopup from "../../../components/CustomPopup.vue";
import Decimal from "decimal.js";
import ImagePreviewComponent from '../../../components/ImagePreviewComponent.vue';
export default {
  name: "InHospitalDetailDispatch",
  components: {
    CustomPopup,
    ImagePreviewComponent
  },
  data() {
    return {
      // 图片预览
      showPreviewComponent: false,
      previewImages: [],
      previewIndex: 0,

      popupType: 1, // 1-服务流程 2-收费管理类别 3-收费管理
      isShowCustomPopup: false,
      popupPosition: "bottom", // 可以设置为 'center' 或 'bottom'

      id: "", // 订单di
      detail: {},
      isLoading: true, // 是否正在加载
      isRefresh: false, // 是否正在刷新

      // 业务流程参数
      serviceProcessParams: {
        order_id: "",
        detailtype: "", // 记录类型 =1=正在前往服务对象住所|2=已抵达服务对象住所|3=已对接服务对象|4=正在前往目的地|5=已抵达目的地|6=服务已完成|7=已陪送返回服务对象住所|
        pic: "",
        pic2: "",
        pic3: "",
        openid: "",
        truename: "",
        hrcode: "",
        phone: "",
        servicetype: "", // 服务类型id
        servicecont: "", // 服务内容id
      },
      // 临时图片储存
      tempPicList: [],
      detailtypeList: [
        // {
        //   text: "正在前往服务对象住所",
        //   html: "正在前往 <br> 服务对象住所",
        //   value: 1,
        //   isShow: false,
        //   // 是否完成
        //   isFinish: false,
        // },
        // {
        //   text: "已抵达服务对象住所",
        //   html: "已抵达服务对象住所",
        //   value: 2,
        //   isShow: false,
        //   // 是否完成
        //   isFinish: false,
        // },
        // {
        //   text: "与服务对象已对接",
        //   html: "与服务对象已对接",
        //   value: 3,
        //   isShow: true,
        //   // 是否完成
        //   isFinish: false,
        // },
        {
          text: "正在前往需要办理手续的医院",
          html: "正在前往<br>需要办理手续的医院",
          value: 4,
          isShow: true,
          // 是否完成
          isFinish: false,
        },
        {
          text: "已到达需要办理手续的医院",
          html: "已到达<br>需要办理手续的医院",
          value: 5,
          isShow: true,
          // 是否完成
          isFinish: false,
        },
        {
          text: "已经完成代办",
          html: "已经完成代办",
          value: 6,
          isShow: true,
          // 是否完成
          isFinish: false,
          type: "radio",
          radioValue: "",
        },
        // {
        //   text: "预约结果附件",
        //   html: "预约结果附件",
        //   value: 8,
        //   isShow: true,
        //   // 是否完成
        //   isFinish: false,
        // },
        {
          text: "代办住院/出院手续服务已完成",
          html: "代办住院/出院手续<br>服务已完成",
          value: 7,
          isShow: true,
          // 是否完成
          isFinish: false,
        },
      ],
      // 功能是否完成
      isFinishShowBtn: false,
      detailtypeobj: "",
      chargeType: "", // 收费管理类别 1-基础服务 2-超时服务 3-额外交通 4-是否确认服务已完成
      // 是否有待处理收费记录
      isHasChargeRecord: false,
      // 是否已处理完成
      isHasFinishCharge: false,
      // 收费金额
      chargeAmount: 0,
      // 是否新增额外收费记录
      isAddExtraCharge: false,
      stepperValue: 0.5, // 步进器初始值
      // 超时金额
      timeoutAmount: 0,

      // 超时费用对象
      timeoutChargeObj: {},
      // 额外交通费用对象
      extraChargeObj: {},
      // 其他额外费用对象
      otherExtraChargeObj: {},
      // 额外费用类型
      extraChargeTypeList: [
        {
          text: "药品购买费用",
          value: 1,
        },
        {
          text: "挂号费",
          value: 2,
        },
        {
          text: "检查预约付费",
          value: 3,
        },
        {
          text: "住院押金",
          value: 4,
        },
        {
          text: "其它额外费用",
          value: 5,
        },
      ],
      extraChargeType: 1,

      // 子表专用信息
      columnSubService: {},
      // 报告材料
      images: [],

      isSubmitting: false, // 是否正在提交
    };
  },
  async mounted() {
    let { openid, truename, accountid, mobile } = this.$store.state.USERINFO;
    this.serviceProcessParams.openid = openid;
    this.serviceProcessParams.truename = truename;
    this.serviceProcessParams.hrcode = accountid;
    this.serviceProcessParams.phone = mobile;

    this.id = this.$route.query.id;
    this.getCommunityServiceOrderDetail();
  },
  methods: {
    // 格式化时间
    formatTime(fieldName) {
      if (fieldName) {
        // 替换 T 为空格
        return fieldName.replace('T', ' ');
      }
      return '';
    },
    
    // 获取订单详情
    async getCommunityServiceOrderDetail() {
      try {
        const res = await getCommunityServiceOrderDetail(this.id);
        this.detail = res;
        // 超时费用
        this.timeoutChargeObj =
          res.park_catering_service_order_fee.length > 0
            ? res.park_catering_service_order_fee[0]
            : {};
        // 额外交通费用
        this.extraChargeObj =
          res.park_catering_service_order_feetraffic.length > 0
            ? res.park_catering_service_order_feetraffic[0]
            : {};
        // 其他额外费用
        this.otherExtraChargeObj =
          res.park_catering_service_order_feeother.length > 0
            ? res.park_catering_service_order_feeother[0]
            : {};

        this.serviceProcessParams.order_id = res.order_id;
        this.serviceProcessParams.servicetype = res.servicetype;
        this.serviceProcessParams.servicecont = res.servicecont;
        this.meachinestatestr = res.meachinestatestr
          ? res.meachinestatestr
          : '不需要附加器具';
        // 处理业务过程进行判断，如果isgetsend=1的时候，detailtypeList里value=1、2的为true，否则为false
        // if (res.isgetsend == 1) {
        //   this.detailtypeList.forEach((item) => {
        //     if (item.value == 1 || item.value == 2) {
        //       item.isShow = true;
        //     }
        //   });
        // }
        // 处理业务过程进行判断，如果res.park_catering_service_order_detail有值，并且detailtype值和detailtypeList中value的值相同的时候，isFinish为true
        if (
          Array.isArray(res.park_catering_service_order_detail) &&
          res.park_catering_service_order_detail.length > 0
        ) {
          res.park_catering_service_order_detail.forEach((item) => {
            if (item.detailtype == 6) {
              this.detailtypeList[3].matchedDetail = item;
              if (item.pic) {
                this.detailtypeList[3].isFinish = true;
              }
            }
          });
          this.detailtypeList.forEach((item) => {
            const matchedItem = res.park_catering_service_order_detail.find(
              (detailItem) => detailItem.detailtype == item.value
            );
            item.isFinish = !!matchedItem;
            item.matchedDetail = matchedItem || null;
          });
        }

        this.getHospitalProceduresList(res.order_id);
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isLoading = false;
      }
    },

    // 获取代办住院出院手续服务
    async getHospitalProceduresList(order_id) {
      try {
        const res = await getHospitalProceduresList({ order_id });
        this.columnSubService = res.list.length > 0 ? res.list[0] : {};
        // 将columnMedDisService里的pic1,pic2,pic3,pic4添加到images数组里，其中值为空的不添加
        this.images = [
          this.columnSubService.certpic1,
          this.columnSubService.certpic2,
          this.columnSubService.certpic3,
          this.columnSubService.certpic4,
          this.columnSubService.certpic5,
          this.columnSubService.certpic6,
          this.columnSubService.certpic7,
          this.columnSubService.certpic8,
          this.columnSubService.certpic9,
        ].filter((pic) => pic);
        this.detailtypeList.forEach((item) => {
          if (item.value == 6) {
            item.radioValue = this.columnSubService.issuc;
          }
        });
      } catch (error) {
        console.error("获取街道列表失败", error);
      }
    },

    // 修改代办住院出院手续服务
    async editHospitalProcedures(data) {
      try {
        let dataForm = {
          id: this.columnSubService.id,
          order_id: this.detail.order_id,
          ...data,
        };
        const res = await editHospitalProcedures(dataForm);
        if (res.result) {
          // 等待 1 秒
          await new Promise((resolve) => setTimeout(resolve, 800));
          this.$toast.success("确认服务流程完成成功");
          this.closeCustomPopup();
          this.getCommunityServiceOrderDetail();
        } else {
          this.$toast.fail(res.message || "确认服务流程完成失败");
        }
      } catch (error) {
        console.error("确认服务流程完成请求出错:", error);
        this.$toast.fail("确认服务流程完成失败，请稍后重试");
      }
    },

    // 处理文件选择事件
    handleFileChange(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        if (this.tempPicList.length >= 3) {
          this.$toast.fail("最多只能上传三张图片");
          break;
        }
        const file = files[i];
        if (file) {
          this.handleChooseImg(file);
        }
      }
      // 清空 input 的值，以便下次选择相同文件时能触发 change 事件
      this.$refs.imageInput.value = "";
    },

    // 上传图片
    async handleChooseImg(data) {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      const formData = new FormData();
      formData.append("imgfile", data);
      try {
        const res = await uploadImage(formData);
        if (res.result) {
          // 等待 500 毫秒
          await new Promise((resolve) => setTimeout(resolve, 500));
          // await this.handleUpload(res.url);
          // 将上传成功的图片 URL 添加到 tempPicList
          this.tempPicList.push(res.url);

          // 根据 tempPicList 长度给 serviceProcessParams 赋值
          switch (this.tempPicList.length) {
            case 1:
              this.serviceProcessParams.pic = res.url;
              break;
            case 2:
              this.serviceProcessParams.pic2 = res.url;
              break;
            case 3:
              this.serviceProcessParams.pic3 = res.url;
              break;
          }
        } else {
          this.$toast.fail(res.message || "上传失败");
        }
      } catch (error) {
        console.error("图片上传请求出错:", error);
        this.$toast.fail("上传失败，请稍后重试");
      } finally {
        toast.clear();
      }
    },

    /**
     * 服务流程相关事件 start
     * 1、确认服务流程完成
     */
    // 1、确认服务流程完成
    async confirmServiceProcess() {
      if (this.detailtypeobj.value == 6) {
        if (this.detailtypeobj.radioValue == "0") {
          this.$toast("请选择是代办手续是否已经完成");
          return;
        }
      }
      if (this.tempPicList.length == 0) {
        this.$toast("请上传照片");
        return;
      }
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      try {
        const res = await addBusinessRecord(this.serviceProcessParams);
        if (res.result) {
          if (this.detailtypeobj.value == 6) {
            this.editHospitalProcedures({
              issuc: this.detailtypeobj.radioValue,
            });
          } else {
            // 等待 1 秒
            await new Promise((resolve) => setTimeout(resolve, 800));
            this.$toast.success("确认服务流程完成成功");
            this.closeCustomPopup();
            this.getCommunityServiceOrderDetail();
          }
        } else {
          this.$toast.fail(res.message || "确认服务流程完成失败");
        }
      } catch (error) {
        console.error("确认服务流程完成请求出错:", error);
        this.$toast.fail("确认服务流程完成失败，请稍后重试");
      }
    },
    /**
     * 确认服务流程完成 end
     */

    /**
     * 收费管理操作 start
     * 第一步：修改陪护服务订单数据
     * 第二步：获取订单详情
     */
    // 1、确认收费管理操作
    async confirmChargeManagement() {
      if (this.isSubmitting || this.isHasFinishCharge) return;

      this.isSubmitting = true;

      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      try {
        if (this.chargeType == 1) {
          // 基础收费
          const currentDate = new Date();
          const formattedDate = this.formatDate(currentDate);
          let data = {
            getmancardno: this.serviceProcessParams.hrcode,
            gettime: formattedDate,
          };
          this.editCommunityServiceOrder(data);
        } else if (this.chargeType == 2) {
          let data = {
            hrcode: this.serviceProcessParams.hrcode,
            order_id: this.detail.order_id,
          };
          this.editTimeoutCharge(data);
        } else if (this.chargeType == 3) {
          let data = {
            hrcode: this.serviceProcessParams.hrcode,
            order_id: this.detail.order_id,
          };
          this.editExtraTransportationCharge(data);
        } else if (this.chargeType == 4) {
          // 其他额外费用
          let data = {
            hrcode: this.serviceProcessParams.hrcode,
            order_id: this.detail.order_id,
          };
          this.editOtherExtraCharge(data);
        }
      } catch (error) {
        console.error("确认收费管理操作请求出错:", error);
        this.$toast.fail("确认收费管理操作失败，请稍后重试");
        this.isSubmitting = false;
      }
    },

    // 2、新增服务管理费用
    async addServiceManagementCharge() {
      if (this.isSubmitting) return;
      this.isSubmitting = false;
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      try {
        if (this.chargeType == 2) {
          // 超时金额
          // if (this.timeoutAmount == 0) {
          //   this.$toast("请输入超时金额");
          //   return;
          // }
          this.addTimeoutCharge();
        } else if (this.chargeType == 3) {
          // 额外交通费用
          if (this.timeoutAmount == 0) {
            this.$toast("请输入交通费用金额");
            return;
          }
          if (this.tempPicList.length == 0) {
            this.$toast("请上传交通凭证图片");
            return;
          }
          this.addExtraTransportationCharge();
        } else if (this.chargeType == 4) {
          // 其他额外费用
          if (this.otherExtraAmount == 0) {
            this.$toast("请输入其他额外费用金额");
            return;
          }
          if (this.tempPicList.length == 0) {
            this.$toast("请上传交通凭证图片");
            return;
          }
          this.addOtherExtraCharge();
        }
      } catch (error) {
        console.error("确认收费管理操作请求出错:", error);
        this.$toast.fail("确认收费管理操作失败，请稍后重试");
        this.isSubmitting = false;
      }
    },

    // 新增收费记录
    addChargeRecord() {
      this.isAddExtraCharge = true;
    },

    // 返回上一步
    returnChargeRecord() {
      this.isAddExtraCharge = false;
    },

    // 步进器
    // 减少数值
    decrement() {
      if (this.stepperValue > 0.5) {
        this.stepperValue = parseFloat((this.stepperValue - 0.5).toFixed(1));
      }
    },
    // 增加数值
    increment() {
      this.stepperValue = parseFloat((this.stepperValue + 0.5).toFixed(1));
    },
    // 处理输入事件
    handleInput(event) {
      let value = parseFloat(event.target.value);
      if (isNaN(value) || value < 0.5) {
        value = 0.5;
      }
      this.stepperValue = parseFloat(value.toFixed(1));
    },
    /**
     * 收费管理操作 end
     */

    // 完成服务
    async confirmFinishService(type) {
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      try {
        // 服务收费金额核算（timeoutprice）=主要服务项目收费（manprice）+产生超时服务追加费用（appendprice）+产生额外交通费用（trafficprice），默认情况下appendprice、trafficprice值为0，使用Decimal进行计算
        let order_price = Decimal(
          this.detail.timeoutprice ? this.detail.timeoutprice : 0
        )
          .add(Decimal(this.detail.appendprice ? this.detail.appendprice : 0))
          .add(Decimal(this.detail.trafficprice ? this.detail.trafficprice : 0))
          .toNumber();
        let data = {
          order_price,
          service_order_status: 5, // 服务订单状态 =1=待接单|2=已接单，待付款|3=已接单，已付款|4=服务中|5=服务已完成（待评价）|6=服务已完成（已评价）|7=服务取消审核中|8=服务已取消|
          service_order_property: type, // 服务订单情况属性 =1=进行中|2=已完成|3=已取消|
        };
        this.editCommunityServiceOrder(data);
      } catch (error) {
        console.error("确认收费管理操作请求出错:", error);
        this.$toast.fail("确认收费管理操作失败，请稍后重试");
        this.isSubmitting = false;
      }
    },

    // 新增超时追加费用
    async addTimeoutCharge() {
      try {
        let fee = this.calculateServiceFee(this.stepperValue);
        let params = {
          order_id: this.detail.order_id,
          ishavefee: 1, // 是否产生服务超时追加费用 =1=是|0=否|
          overhours: this.stepperValue,
          fee,
          paystate: 0, // 支付类型 =1=线上支付|0=线下现金结算|
          checkstate: 0,
        };
        let res = await addTimeoutCharge(params);
        if (res.result == "true") {
          // 等待 800 毫秒后关闭加载提示
          await new Promise((resolve) => setTimeout(resolve, 500));
          // 超时
          let data = {
            istimeout: 1, // 服务是否超时 =1=是|0=否|
            timeoutnum: this.stepperValue,
            isappend: 1, // 是否产生超时服务追加费用 =1=是|0=否|
            appendprice: fee,
          };
          await this.editCommunityServiceOrder(data);
        } else {
          this.$toast.fail(res.message || "更新失败");
        }
      } catch (error) {
        this.$toast.fail(res.message || "更新失败");
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 200));
        this.isSubmitting = false;
      }
    },

    // 修改超时追加费用
    async editTimeoutCharge(data) {
      try {
        let params = {
          id: this.detail.park_catering_service_order_fee[0].id,
          ...data,
        };
        let res = await editTimeoutCharge(params);
        if (res.result == "true") {
          // 等待 800 毫秒后关闭加载提示
          await new Promise((resolve) => setTimeout(resolve, 500));
          this.$toast.success("确认成功");
          this.closeCustomPopup();
          // 基础收费
          // 第二步：获取订单详情
          await this.getCommunityServiceOrderDetail();
        } else {
          this.$toast.fail(res.message || "更新失败");
        }
      } catch (error) {
        this.$toast.fail(res.message || "更新失败");
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 200));
        this.isSubmitting = false;
      }
    },

    // 新增额外交通费用
    async addExtraTransportationCharge() {
      try {
        let params = {
          order_id: this.detail.order_id,
          ishavefee: 1, // 是否产生额外交通费用 =1=是|0=否|
          fee: this.timeoutAmount,
          paystate: 0, // 支付类型 =1=线上支付|0=线下现金结算|
          pic1: this.tempPicList[0] || "",
          pic2: this.tempPicList[1] || "",
          pic3: this.tempPicList[2] || "",
          checkstate: 0,
        };
        let res = await addExtraTransportationCharge(params);
        if (res.result == "true") {
          // 等待 800 毫秒后关闭加载提示
          await new Promise((resolve) => setTimeout(resolve, 500));
          // 超时
          let data = {
            istraffic: 1, // 是否产生交通费用 =1=是|0=否|
            trafficprice: this.timeoutAmount,
          };
          await this.editCommunityServiceOrder(data);
        } else {
          this.$toast.fail(res.message || "更新失败");
        }
      } catch (error) {
        this.$toast.fail(res.message || "更新失败");
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 200));
        this.isSubmitting = false;
      }
    },

    // 修改额外交通费用
    async editExtraTransportationCharge(data) {
      try {
        let params = {
          id: this.detail.park_catering_service_order_feetraffic[0].id,
          ...data,
        };
        let res = await editExtraTransportationCharge(params);
        if (res.result == "true") {
          // 等待 800 毫秒后关闭加载提示
          await new Promise((resolve) => setTimeout(resolve, 500));
          this.$toast.success("确认成功");
          this.closeCustomPopup();
          // 基础收费
          // 第二步：获取订单详情
          await this.getCommunityServiceOrderDetail();
        } else {
          this.$toast.fail(res.message || "更新失败");
        }
      } catch (error) {
        this.$toast.fail(res.message || "更新失败");
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 200));
        this.isSubmitting = false;
      }
    },

    // 新增其他额外费用
    async addOtherExtraCharge() {
      try {
        let params = {
          order_id: this.detail.order_id,
          ishavefee: 1, // 是否产生其它额外费用 =1=是|0=否|
          fee: this.timeoutAmount,
          feetype: this.extraChargeType, // 其它额外费用类型 =1=药品购买费用|2=挂号费|3=检查预约付费|4=住院押金|5=其它额外费用|
          paystate: 0, // 支付类型 =1=线上支付|0=线下现金结算|
          pic1: this.tempPicList[0] || "",
          pic2: this.tempPicList[1] || "",
          pic3: this.tempPicList[2] || "",
          checkstate: 0,
        };
        let res = await addOtherExtraCharge(params);
        if (res.result == "true") {
          // 等待 800 毫秒后关闭加载提示
          await new Promise((resolve) => setTimeout(resolve, 500));
          this.$toast.success("确认成功");
          this.closeCustomPopup();
          // 第二步：获取订单详情
          await this.getCommunityServiceOrderDetail();
        } else {
          this.$toast.fail(res.message || "更新失败");
        }
      } catch (error) {
        this.$toast.fail(res.message || "更新失败");
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 200));
        this.isSubmitting = false;
      }
    },

    // 修改其他额外费用
    async editOtherExtraCharge(data) {
      try {
        let params = {
          id: this.detail.park_catering_service_order_feeother[0].id,
          ...data,
        };
        let res = await editOtherExtraCharge(params);
        if (res.result == "true") {
          // 等待 800 毫秒后关闭加载提示
          await new Promise((resolve) => setTimeout(resolve, 500));
          this.$toast.success("确认成功");
          this.closeCustomPopup();
          // 基础收费
          // 第二步：获取订单详情
          await this.getCommunityServiceOrderDetail();
        } else {
          this.$toast.fail(res.message || "更新失败");
        }
      } catch (error) {
        this.$toast.fail(res.message || "更新失败");
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 200));
        this.isSubmitting = false;
      }
    },

    // 修改陪护服务订单数据
    async editCommunityServiceOrder(data) {
      try {
        let params = {
          id: this.id,
          ...data,
        };
        let res = await editCommunityServiceOrder(params);
        if (res.result == "true") {
          // 等待 800 毫秒后关闭加载提示
          await new Promise((resolve) => setTimeout(resolve, 500));
          this.$toast.success("确认成功");
          this.closeCustomPopup();
          // 基础收费
          // 第二步：获取订单详情
          await this.getCommunityServiceOrderDetail();
        } else {
          this.$toast.fail(res.message || "更新失败");
        }
      } catch (error) {
        this.$toast.fail(res.message || "更新失败");
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 200));
        this.isSubmitting = false;
      }
    },

    // 删除图片
    removeImage(index) {
      this.tempPicList.splice(index, 1);
      // 重置 serviceProcessParams 中的图片 URL
      this.serviceProcessParams.pic = this.tempPicList[0] || "";
      this.serviceProcessParams.pic2 = this.tempPicList[1] || "";
      this.serviceProcessParams.pic3 = this.tempPicList[2] || "";
    },

    // 下拉刷新
    async onRefresh() {
      // 等待 800 毫秒后关闭加载提示
      await new Promise((resolve) => setTimeout(resolve, 500));
      this.isRefresh = false;
      this.getCommunityServiceOrderDetail();
    },

    // 显示添加人员弹窗
    showCustomPopup(position, type, item) {
      /**
       * 判断是否服务完成的时候，有以下需求
       * 1、detailtypeList中如果对象的isShow为true的时候，isFinish都为true才进行下一步；
       * 2、如果timeoutChargeObj对象有值。当paytype为1时，则进行下一步；当paytype为0时，hrcode不为空则进行下一步；
       * 3、如果chargeRecordObj对象有值。当paytype为1时，则进行下一步；当paytype为0时，hrcode不为空则进行下一步
       */
      if (type == 4) {
        if(this.detail.service_order_status < 3 || (this.detail.paytype == 2 && !this.detail.getmancardno)) return // 未支付订单则禁止处理

        // 需求 1：检查 detailtypeList 中 isShow 为 true 的对象的 isFinish 是否都为 true
        const allShowItemsFinished = this.detailtypeList
          .filter((item) => item.isShow)
          .every((item) => item.isFinish);

        // 需求 2：检查 timeoutChargeObj 对象
        let timeoutChargeValid = true;
        if (Object.keys(this.timeoutChargeObj).length > 0) {
          if (this.timeoutChargeObj.paytype == 1) {
            timeoutChargeValid = true;
          } else if (this.timeoutChargeObj.paytype == 0) {
            timeoutChargeValid = !!this.timeoutChargeObj.hrcode;
          } else {
            timeoutChargeValid = false;
          }
        }

        // 需求 3：检查 chargeRecordObj 对象（假设 chargeRecordObj 存在于 data 中）
        let chargeRecordValid = true;
        if (Object.keys(this.chargeRecordObj || {}).length > 0) {
          if (this.chargeRecordObj.paytype == 1) {
            chargeRecordValid = true;
          } else if (this.chargeRecordObj.paytype == 0) {
            chargeRecordValid = !!this.chargeRecordObj.hrcode;
          } else {
            chargeRecordValid = false;
          }
        }
        if (
          !allShowItemsFinished &&
          !timeoutChargeValid &&
          !chargeRecordValid
        ) {
          this.$toast.fail("请先完成服务流程");
          return;
        }
        if (!allShowItemsFinished) {
          this.$toast.fail("请先完成所有显示的服务流程");
          return;
        }
        if (!timeoutChargeValid) {
          this.$toast.fail("请确认超时费用结算");
          return;
        }
        if (!chargeRecordValid) {
          this.$toast.fail("请确认额外交通费用结算");
          return;
        }
      }
      this.popupType = type;
      // 服务流程处理
      if (type == 1) {
        if(this.detail.service_order_status < 3 || (this.detail.paytype == 2 && !this.detail.getmancardno)) return // 未支付订单则禁止处理
        
        this.serviceProcessParams.detailtype = item.value;
        this.detailtypeobj = item;
        if (item.isFinish) {
          this.isFinishShowBtn = true;
          // 清空 tempPicList
          this.tempPicList = [];
          // 将 item 中有值的图片添加到 tempPicList
          if (item.matchedDetail && item.matchedDetail.pic) {
            this.tempPicList.push(item.matchedDetail.pic);
          }
          if (item.matchedDetail && item.matchedDetail.pic2) {
            this.tempPicList.push(item.matchedDetail.pic2);
          }
          if (item.matchedDetail && item.matchedDetail.pic3) {
            this.tempPicList.push(item.matchedDetail.pic3);
          }
          if (item.matchedDetail && item.matchedDetail.pic4) {
            this.tempPicList.push(item.matchedDetail.pic4);
          }
          if (item.matchedDetail && item.matchedDetail.pic5) {
            this.tempPicList.push(item.matchedDetail.pic5);
          }
          if (item.matchedDetail && item.matchedDetail.pic6) {
            this.tempPicList.push(item.matchedDetail.pic6);
          }
          if (item.matchedDetail && item.matchedDetail.pic7) {
            this.tempPicList.push(item.matchedDetail.pic7);
          }
          if (item.matchedDetail && item.matchedDetail.pic8) {
            this.tempPicList.push(item.matchedDetail.pic8);
          }
          if (item.matchedDetail && item.matchedDetail.pic9) {
            this.tempPicList.push(item.matchedDetail.pic9);
          }
        } else {
          this.serviceProcessParams.pic = "";
          this.serviceProcessParams.pic2 = "";
          this.serviceProcessParams.pic3 = "";
          this.tempPicList = [];
          this.isFinishShowBtn = false;
        }
      }
      // 收费管理类型
      if (type == 3) {
        let { detail } = this;
        this.isHasChargeRecord = false;
        this.isHasFinishCharge = false;
        this.chargeAmount = "";
        this.tempPicList = [];
        if (item == 1) {
          // 基础费用
          this.isHasChargeRecord = detail.ispay == 1 ? true : false;
          this.isHasFinishCharge = detail.getmancardno ? true : false;
          this.chargeAmount = detail.timeoutprice;
        } else if (item == 2) {
          // 超时服务费用
          this.isHasChargeRecord =
            detail.park_catering_service_order_fee.length > 0 &&
            detail.park_catering_service_order_fee[0].paystate == 1
              ? true
              : false;
          this.isHasFinishCharge =
            detail.park_catering_service_order_fee.length > 0 &&
            detail.park_catering_service_order_fee[0].hrcode
              ? true
              : false;
          this.chargeAmount = detail.appendprice;
        } else if (item == 3) {
          // 额外交通费用
          this.isHasChargeRecord =
            detail.park_catering_service_order_feetraffic.length > 0 &&
            detail.park_catering_service_order_feetraffic[0].paystate == 1
              ? true
              : false;
          this.isHasFinishCharge =
            detail.park_catering_service_order_feetraffic.length > 0 &&
            detail.park_catering_service_order_feetraffic[0].hrcode
              ? true
              : false;
          this.chargeAmount = detail.trafficprice;
        } else if (item == 4) {
          // 其他额外费用 park_catering_service_order_feeother
          this.isHasChargeRecord =
            detail.park_catering_service_order_feeother.length > 0 &&
            detail.park_catering_service_order_feeother[0].paystate == 1
              ? true
              : false;
          this.isHasFinishCharge =
            detail.park_catering_service_order_feeother.length > 0 &&
            detail.park_catering_service_order_feeother[0].hrcode
              ? true
              : false;
          this.chargeAmount =
            detail.park_catering_service_order_feeother.length > 0
              ? detail.park_catering_service_order_feeother[0].fee
              : 0;
        }
        this.chargeType = item;
      }
      this.popupPosition = position;
      this.popupPosition = position;
      this.isShowCustomPopup = true;
      this.isAddExtraCharge = false;
    },
    closeCustomPopup() {
      this.isShowCustomPopup = false;
    },

    /**
     * 服务超时费用核算
     * @param {number} duration 超时服务时长（小时）
     * @returns {number} 服务超时总费用
     */
    calculateServiceFee(duration) {
      // 半小时费用为 50，一小时费用为 100
      const halfHourFee = 50;
      const oneHourFee = 100;

      // 计算超时总费用
      let timeoutFee = 0;
      if (duration >= 1) {
        const fullHours = Math.floor(duration);
        const remainingHours = duration - fullHours;
        timeoutFee = fullHours * oneHourFee;
        if (remainingHours >= 0.5) {
          timeoutFee += halfHourFee;
        }
      } else if (duration >= 0.5) {
        timeoutFee = halfHourFee;
      }
      return timeoutFee;
    },

    // 格式化日期函数
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    handleReturn() {
      this.$router.back();
    },

    // 预览图片
    previewImage(index, images) {
      this.showPreviewComponent = true
      this.previewImages = images;
      this.previewIndex = index
    },
    // 关闭图片预览
    closePreview() {
      this.showPreviewComponent = false;
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy-icon");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
  
  <style lang="less">
  .order-detail-page {}
</style>